import React, { ReactElement, Component, useState, useEffect, useContext, Fragment, useMemo } from "react";
import { Select, Row, Col } from "antd";
import { ClusterSelectedContext } from "../../contexts/cluster-selected";
import { item } from "../../contexts/items";
import { WorkSpaceSelectedContext } from "../../contexts/workspace-selected";
import { WorkspaceContext, workspaces_type_item } from "../../contexts/workspaces";
import { select_display, select } from "../table-list/table-list";
import { withRouter } from "react-router-dom";
import { WorkSpaceSelectContext } from "../../contexts/workspace-select";
import { FormattedMessage } from "react-intl";
import { NamespaceContext, namespaces_type_item } from "../../contexts/namespaces";
import { NameSpaceSelectedContext } from "../../contexts/namespace-selected";
import { ClusterContext, clusters_type_item } from "../../contexts/clusters";
import DropdownMenuSubscription from "../dropdown-menu-subscription/dropdown-menu-subscription";

const DropdownMenu: React.FC = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
    const clusters: clusters_type_item[] = useContext(ClusterContext)[0],
        [workspaces, set_workspaces]: [workspaces_type_item[] | undefined, React.Dispatch<React.SetStateAction<workspaces_type_item[] | undefined>>] = useContext(WorkspaceContext),
        [namespaces, set_namespaces]: [namespaces_type_item[] | undefined, React.Dispatch<React.SetStateAction<namespaces_type_item[] | undefined>>] = useContext(NamespaceContext),
        [cluster_selected, set_cluster_selected]: [item | undefined, React.Dispatch<React.SetStateAction<item | undefined>>] = useContext(ClusterSelectedContext),
        [workspace_selected, set_workspace_selected]: [item | undefined, React.Dispatch<React.SetStateAction<item | undefined>>] = useContext(WorkSpaceSelectedContext),
        [namespace_selected, set_namespace_selected]: [item | undefined, React.Dispatch<React.SetStateAction<item | undefined>>] = useContext(NameSpaceSelectedContext),
        [workspace_select, set_workspace_select]: [JSX.Element[], React.Dispatch<React.SetStateAction<JSX.Element[]>>] = useContext(WorkSpaceSelectContext),

        [cluster_select, set_cluster_select]: [JSX.Element, React.Dispatch<React.SetStateAction<JSX.Element>>] = useState<JSX.Element>(<p></p>),

        path = useMemo(() => props.history.location.pathname.substring(1), [props.history.location.pathname]),
        { Option } = useMemo(() => Select, []);

    // Cluster 下拉選單
    useEffect((): void => {
        set_cluster_select(
            <Select size="large" style={{ width: '100%', paddingLeft: 2 }}
                showSearch
                optionFilterProp="children"
                value={(cluster_selected || { name: '' }).name}
                disabled={!clusters.length}
                onChange={(event: string) => {
                    const cluster_found = (clusters.find((cluster: clusters_type_item) => cluster.metadata.name === event) || {}).metadata;
                    // set_role('');
                    set_cluster_selected(cluster_found);
                    set_workspaces(undefined);
                    set_namespaces(undefined);
                    set_workspace_selected(undefined);
                    sessionStorage.setItem('cluster', (cluster_found || {}).name || '');
                    sessionStorage.removeItem('workspace');
                }}>
                {Array.isArray(clusters) && clusters
                    .map((cluster: clusters_type_item) => <Option key={cluster.metadata.name} value={cluster.metadata.name}>{cluster.metadata.name}</Option>)}
            </Select>
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cluster_selected?.name, set_cluster_selected, set_workspace_selected, clusters]);

    // Workspace 下拉選單
    useEffect((): void => {
        if (!workspace_selected?.labels && workspaces?.length) {
            const workspace_found = workspaces.find(workspace => workspace.metadata.name === workspace_selected?.name);
            workspace_found && set_workspace_selected(workspace_found.metadata);
        }
        const workspace_select_new = ([
            select_display(path).workspace && workspaces && <Col sm={4} className="px-6">
                <Row>
                    <span title='workspace' className="font-14"><FormattedMessage id="workspace" /></span>
                    <Select disabled={!workspaces.length} showSearch optionFilterProp="children" size="large" value={workspace_selected?.labels ? workspace_selected.labels.name : workspaces[0] && workspaces[0].metadata.labels?.name} style={{ width: '100%', paddingLeft: 2 }} onChange={(event: string) => { select(event, set_workspace_selected, true, workspaces); set_namespaces(undefined); set_namespace_selected(undefined) }}>
                        {workspaces[0] && workspaces.map((workspace: workspaces_type_item, index: number) => <Option key={workspace.metadata.name + index} value={workspace.metadata.labels?.name}>{workspace.metadata.labels?.name}</Option>)}
                    </Select>
                </Row>
            </Col>,
            <Select disabled={!(workspaces || {}).length} value={workspace_selected?.labels ? workspace_selected.labels.name : workspaces && workspaces[0]?.metadata.labels?.name} style={{ width: '100%', paddingLeft: 2 }} onChange={(event: string) => { select(event, set_workspace_selected, true, workspaces); set_namespaces(undefined); set_namespace_selected(undefined) }}>
                {workspaces?.length && workspaces?.map((workspace: workspaces_type_item, index: number) => <Option key={workspace.metadata.name + index} value={workspace.metadata.labels?.name}>{workspace.metadata.labels?.name}</Option>)}
            </Select>
        ]);
        set_workspace_select(workspace_select_new as JSX.Element[]);
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [path, workspace_selected, workspaces, set_workspace_selected, set_workspace_select, set_namespace_selected, set_namespaces]);

    // Namespace 下拉選單
    const namespace_select = useMemo((): JSX.Element | undefined => {
        if (!namespace_selected?.labels && namespaces?.length) {
            const namespace_found = namespaces.find(namespace => namespace.metadata.name === namespace_selected?.name);
            namespace_found && set_namespace_selected(namespace_found.metadata);
        }
        return select_display(path).namespace && namespaces ?
            <Col sm={4} className="px-6">
                <Row>
                    <span title='namespace' className="font-14"><FormattedMessage id="namespace" /></span>
                    <Select disabled={!namespaces.length} showSearch optionFilterProp="children" size="large" value={namespace_selected ? namespace_selected.name : namespaces[0] && namespaces[0].metadata.name} style={{ width: '100%', paddingLeft: 2 }} onChange={(event: string) => { select(event, set_namespace_selected, false, namespaces) }}>
                        {namespaces[0] && namespaces.map((namespace: namespaces_type_item) => <Option key={namespace.metadata.uid} value={namespace.metadata.name}>{namespace.metadata.name}</Option>)}
                    </Select>
                </Row>
            </Col >
            :
            undefined;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [path, namespace_selected?.name, namespaces, set_namespace_selected]);

    return (
        <Fragment>
            <Col sm={4} className="px-6"><DropdownMenuSubscription /></Col>
            {select_display(path).cluster}
            {select_display(path).cluster && <Col sm={4} className="px-6">
                <Row>
                    <span title='cluster' className="font-14"><FormattedMessage id="cluster" /></span>
                    {cluster_select}
                </Row>
            </Col>}
            {workspace_select[0]}
            {namespace_select}
        </Fragment>
    )
}

export default withRouter(DropdownMenu);
